<template>
  <f7-page class="apply-teaching-page">
    <f7-navbar title="我的教課資訊" back-link="Back">
      <f7-nav-right>
        <f7-link icon="icon-bars" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar> 
    <div class="wave-header sticky-top"></div>

    <div class="list">
      <ul>
        <li class="input-hint">請填寫自我介紹、教授科目、教課時間：</li>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-input-wrap">
              <textarea row="2" class="resizable filled" v-model="introduce" placeholder="例如：目前就讀法律系二年級，可以教授的科目有初級民法、西洋歷史...。">
                
              </textarea>
            </div>
          </div>
        </li>

        <li class="item-content">
          <div class="item-inner toggle-info">
            <div>
              <p>公開</p>
              <span>所有人皆可搜尋到您</span>
            </div>

            <label class="toggle toggle-init" @click="optionChange()">
              <template v-if="canSearch === true ">
                <input type="checkbox"  checked />
              </template>
              <template v-else>
                <input type="checkbox" />
              </template>
              <span class="toggle-icon"></span>
            </label>
          </div>
        </li>
      </ul>
    </div>

    <!--
    <f7-list class="teaching-select-list">
      <f7-list-item title="請選擇科系" smart-select>
        <select name="科系">
          <option value="apple" selected>公開</option>
          <option value="pear">隱藏</option>
        </select>
      </f7-list-item>
    </f7-list>
    
    <f7-button class="button-large" @click="checkHref('teaching2')">搜尋</f7-button>
    -->
    <f7-button class="button-large" @click="openPrompt()">儲存</f7-button>
  </f7-page>
</template>

<script>
import Service from "../../../service";
import PopModalTest from "./PopModalTest";
import axios from '../../../js/axiosModule';

var moment = require('moment');
export default {
  components: {},
  data() {
    return {
      introduce :'',
      canSearch :true,
      cacheStudentData : null,
      dish: Service.getDish(this.$f7route.params.id)
    };
  },
  methods: {
    queryTutorInfor : function() {
      let self= this;
      var params = {};
      params.queryType="studentno";
      params.queryString=self.$store.state.userInfo.studentNo;
      params.coachType = 0;
      params.activeTime = new Date(self.getNowTime());
      params.canSearch = true;
      //console.dir(params);
       axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/GetCoachStudent",params).then((response)=> {
         self.cacheStudentData = response.data.data;
        self.introduce = response.data.data.introduce;
        self.canSearch = response.data.data.canSearch;
       //self.canSearch = false;
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
    },
    getNowTime : function() {
      var today = new Date();
      var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
      var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      var dateTime = moment(date+' '+time, "YYYY-MM-DD HH:mm:ss")._d;
 
      return dateTime;
    },
    getCreatedDate : function (createdAt) {
      console.log(createdAt);
      createdAt= createdAt.split("+")[0].replace("T"," ");
      
      var dateTime = moment(createdAt, "YYYY-MM-DD HH:mm:ss")._d;
      console.log(dateTime);
      return dateTime;
    },
    openPrompt: function() {
      let self = this;
      var params={};
      params.setYear = self.cacheStudentData.setYear;
      params.setTerm = self.cacheStudentData.setTerm;
      params.studentNo = self.cacheStudentData.studentNo;
      params.coachType = self.cacheStudentData.coachType;
      params.chineseName = self.cacheStudentData.chineseName;
      params.introduce = self.introduce;
      params.startAt = self.cacheStudentData.startAt;
      params.endAt = self.cacheStudentData.endAt;
      params.canSearch = self.canSearch;
      params.createdBy = self.cacheStudentData.createdBy;
      params.createdAt = self.cacheStudentData.createdAt;
   //   console.log(self.getCreatedDate(params.createdAt));
      params.updatedBy = self.cacheStudentData.updatedBy
      params.updatedAt = self.getNowTime();
    
      axios.axiosTokenPost(self.$app.axiosUrl+"/api/Coach/UpdateCoachStudent",params).then((response)=> {
  
        if(response.data.status != 200) {
          //alert("update fail!");
        } else {
          this.$dialog.modal({
            component: PopModalTest,
            title: "已發佈授課服務",
            showCloseBtn: this.checked,
            params: { firstInput: "" },
            callback: p => {
              //this.$dialog.alert("已進入媒合中", {
                //type: "success",
                //showIcon: false
              //});
            }
          });
        }
      }).catch(err=>function() {
        if ( self.$store.state.userInfo === undefined || self.$store.state.userInfo === null ) {
           self.$f7router.navigate("/login");
        } 
      });
      
    },
    checkHref: function(linkText) {
      this.$f7router.navigate("/" + linkText);
    },
    optionChange : function () {
      let self = this;
      self.canSearch = !self.canSearch;
    }
  },mounted() {
    let self = this;
    self.queryTutorInfor();
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/academic-counseling/teaching-counseling/teaching-step1.vue